export default "__VITE_ASSET__7ac53730__"